import { CommonClaimService } from '@savgroup-front-common/core/api';

import {
  createClaimGroupFromOrder,
  getClaimGroupCarrier,
  getClaimGroupClaimSummariesLegacy,
  getClaimGroupConfirmationLegacy,
  getClaimGroupHandling,
  getClaimGroupHandlingLegacy,
  setClaimGroupConfirmation,
  setClaimGroupHandling,
} from './claimGroup';
import { getClaimGroupCarrierLegacy } from './claimGroup/getClaimGroupCarrierLegacy';
import getClaimGroupClaimSummaries from './claimGroup/getClaimGroupClaimSummaries';
import getClaimGroupConfirmation from './claimGroup/getClaimGroupConfirmation';
import { newCreateClaimGroupFromOrder } from './claimGroup/newCreateClaimGroupFromOrder';
import { claimIgnoreDateRules } from './claimIgnoreDateRules';
import createClaimContextForGenericProductCommand from './createClaimContextForGenericProductCommand';
import createInvoiceForClaimGroupCommand from './createInvoiceForClaimGroupCommand';
import { deleteClaimContext } from './deleteClaimContext';
import { deleteClaimContexts } from './deleteClaimContexts';
import deleteClaimGroupCommand from './deleteClaimGroupCommand';
import deleteDiagnosticTreeConfigurationCommand from './deleteDiagnosticTreeConfigurationCommand';
import getClaimConfirmation from './getClaimConfirmation';
import getClaimDebuggingContextQuery from './getClaimDebuggingContextQuery';
import { getClaimGroupIssuesQuery } from './getClaimGroupIssuesQuery';
import getClaimGroupQuery from './getClaimGroupQuery';
import { getClaimGroupReasonsQuery } from './getClaimGroupReasonsQuery';
import { getClaimGroupSolutionsQuery } from './getClaimGroupSolutionsQuery';
import { getClaimReasonComment } from './getClaimReasonComment';
import getClaimsByOrderId from './getClaimsByOrderId';
import getClaimSolutions from './getClaimSolutions';
import getDebuggingClaimInfo from './getDebuggingClaimInfo';
import { getMultiProcedure } from './getMultiProcedure';
import getRulesDebuggingActorGeographic from './getRulesDebuggingActorGeographic';
import getRulesDebuggingActorSolutionsAndPrice from './getRulesDebuggingActorSolutionsAndPrice';
import getRulesDebuggingSolutionTypes from './getRulesDebuggingSolutionTypes';
import getRulesDebuggingWarranties from './getRulesDebuggingWarranties';
import getStoreActors from './getStoreActors';
import getWarrantiesForClaimQuery from './getWarrantiesForClaimQuery';
import handleDiagnosticResponseCommandQuery from './handleDiagnosticResponseCommandQuery';
import reopenFile from './reopenFile';
import setClaimAdditionalInformationCommand from './setClaimAdditionalInformationCommand';
import { setClaimAdditionalInformationWithFilesCommand } from './setClaimAdditionalInformationWithFilesCommand';
import { setClaimGroupIssueCommand } from './setClaimGroupIssueCommand';
import { setClaimGroupReasonCommand } from './setClaimGroupReasonCommand';
import setStoreActor from './setStoreActor';
import startOrContinueDiagnosticTreeQuery from './startOrContinueDiagnosticTreeQuery';

export const ClaimService = {
  getClaimGroupClaimSummariesLegacy,
  createClaimGroupFromOrder,
  getClaimGroupConfirmationLegacy,
  getClaimGroupHandlingLegacy,
  getClaimGroupCarrierLegacy,

  reopenFile,
  getMultiProcedure,
  claimIgnoreDateRules,
  getClaimReasonComment,
  deleteClaimContext,
  deleteClaimContexts,
  getClaimConfirmation,
  getClaimsByOrderId,
  getClaimSolutions,
  getDebuggingClaimInfo,
  getRulesDebuggingActorGeographic,
  getRulesDebuggingActorSolutionsAndPrice,
  getRulesDebuggingSolutionTypes,
  getRulesDebuggingWarranties,
  getStoreActors,
  getClaimGroupClaimSummaries,
  getClaimGroupConfirmation,
  setStoreActor,
  getClaimGroupCarrier,
  getClaimGroupHandling,
  setClaimGroupConfirmation,
  setClaimConfirmationCommand: CommonClaimService.setClaimConfirmationCommand,
  setClaimGroupHandling,
  setClaimGroupHandlingTransportPlanCommand:
    CommonClaimService.setClaimGroupHandlingTransportPlanCommand,
  createClaimContextForGenericProductCommand,
  createInvoiceForClaimGroupCommand,
  getWarrantiesForClaimQuery,
  getClaimDebuggingContextQuery,
  getClaimGroupQuery,
  startOrContinueDiagnosticTreeQuery,
  handleDiagnosticResponseCommandQuery,
  getClaimGroupIssuesQuery,
  setClaimGroupIssueCommand,
  setClaimGroupReasonCommand,
  getClaimGroupSolutionsQuery,
  getClaimGroupReasonsQuery,
  setClaimGroupSolutionCommand: CommonClaimService.setClaimGroupSolutionCommand,
  deleteDiagnosticTreeConfigurationCommand,
  setClaimAdditionalInformationWithFilesCommand,
  deleteClaimGroupCommand,
  getClaimGroupTransportPlanQuery:
    CommonClaimService.getClaimGroupTransportPlanQuery,
  newCreateClaimGroupFromOrder: newCreateClaimGroupFromOrder,
  setClaimAdditionalInformationCommand,
  getClaimGroupConfirmationQuery:
    CommonClaimService.getClaimGroupConfirmationQuery,
  setClaimGroupAdditionalInformationCommand:
    CommonClaimService.setClaimGroupAdditionalInformationCommand,
  uploadSharedFileCommand: CommonClaimService.uploadSharedFileCommand,
};
